import React from "react";

export const PriceShimmer = ({ className }) => (
  <div className={`${className} tbk-relative tbk-overflow-hidden`}>
    <div
      className={"tbk-h-4 tbk-w-9 tbk-rounded-lg tbk-bg-grey-light tbk-pt-0.5"}
    />
    <div
      className={
        "tbk-absolute tbk-bottom-0 tbk-left-0 tbk-right-0 tbk-top-0 tbk-animate-placeholder-shimmer tbk-bg-coach-card-placeholder"
      }
    />
  </div>
);
